import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

import { CustomDotPageAssetLayoutColumn } from '../../../models/page/custom-dot-cms-page.model';

@Component({
  selector: 'custom-dot-cms-row',
  templateUrl: './dot-cms-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsRowComponent {
  readonly columns = input<CustomDotPageAssetLayoutColumn[]>(undefined);
  readonly deviceType = input<DeviceType>(undefined);
  getRowCss(column: CustomDotPageAssetLayoutColumn, index: number) {
    const columnOffset: number[] = [];
    if (index === 0) {
      return column?.width
        ? this.deviceType() === 'tablet'
          ? `col-md-${column.width} offset-md-${column.left}`
          : `col-lg-${column.width} offset-lg-${column.left}`
        : '';
    } else {
      let offset = 0;
      this.columns().forEach((col, indexOfColumn) => {
        if (indexOfColumn === 0) {
          offset = col.left;
          columnOffset.push(offset);
          offset = offset + col.width;
        } else {
          offset = col.left - offset;
          columnOffset.push(offset);
          offset = col.left + col.width;
        }
      });

      return column?.width
        ? this.deviceType() === 'tablet'
          ? `col-md-${column.width} offset-md-${columnOffset[index]}`
          : `col-lg-${column.width} offset-lg-${columnOffset[index]}`
        : '';
    }
  }
}
